const assetsPageNames = {
    WIFI_CONNECTION_GUIDE_SLIDE_4: 'WIFI_CONNECTION_GUIDE_SLIDE_4',
    BLE_CONNECTION_GUIDE_SLIDE_4: 'BLE_CONNECTION_GUIDE_SLIDE_4',
    APP_INSTALLATION_GUIDE: 'APP_INSTALLATION_GUIDE',
};

export default assetsPageNames;
